import { combineReducers } from 'redux';

import answers from '../data/answerSlice.js';
import network from '../data/networkSlice.js';
import procedure from '../data/procedureSlice.js';
import ui from '../data/uiSlice.js';

export default combineReducers({ answers, procedure, network, ui });
